import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9af2b44a&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=9af2b44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af2b44a",
  null
  
)

export default component.exports